import { render, staticRenderFns } from "./InitialLoading.vue?vue&type=template&id=6c13e6e4"
import script from "./InitialLoading.vue?vue&type=script&lang=ts"
export * from "./InitialLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports